import styled from 'styled-components';
import {
  ButtonBase,
  PrimaryLink,
} from '../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import Image from '@stencil/image';

export const RoomDetailsHeaderWrap = styled.div(
  props => `
  display:flex;
  position:sticky;
  top:0;
  border-bottom: 1px solid  ${props.theme.colors.goBrandBlue.light};
  background-color: ${props.theme.colors.goWhite.base};
  margin-bottom:${props.theme.spacing.large};
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${props.theme.spacing.large};
  z-index: ${props.theme.misc.zIndex.small};
  padding: ${props.theme.spacing.xlarge};
  border-radius: ${props.theme.misc.borderRadius.custom(17)};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  
  `,
);

export const RoomAmenitiesBodyWrap = styled.div(
  props => `
  padding: 0;
  max-height:50rem;
  overflow-y:auto;
  `,
);

export const Sub_header_para = styled.p(
  props => `
  color: ${props.theme.colors.downriver.medium};
  font-size: ${props.theme.font.custom(16)};
  margin-top:${props.theme.spacing.small};
    `,
);

export const PlanTag = styled.div(
  props => `
  position:absolute;
  top:-40px;
  background-color:#eb6125;
  color:${props.theme.colors.goWhite.base};
  left:22px;
  font-size: ${props.theme.font.custom(18)};
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large};
  border-top-left-radius:14px;
  border-top-right-radius:14px;
  font-weight: 600;
  `,
);

export const List_Container = styled.div(
  props => `
  border-bottom:1px solid #e1e7ee;
  padding: 0 ${props.theme.spacing.custom(24)} ${props.theme.spacing.custom(
    24,
  )} ${props.theme.spacing.custom(24)};
  `,
);

export const Cancel_Container = styled.div(
  props => `
  
  padding: ${props.theme.spacing.custom(24)};
  `,
);

export const Cancel_policy_wrap = styled.div(
  props => `
    display:flex;
    flex-direction: column;
    `,
);

export const BaseColumnWrap = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    width:100%;
    `,
);

export const Header_p = styled.p(
  props => `
  font-size: ${props.theme.font.custom(16)};
  font-weight: 600;
  margin-bottom:${props.theme.spacing.small};
  `,
);
